import { CircleCheckIcon, ExclamationCircleIcon } from '@panwds/icons';
import { classNames } from '@panwds/tailwindcss';
import React, { useEffect, useState } from 'react';
import { testIdGen } from '../../utils/index.js';
import { LoadingIcon } from '../Icon/index.js';
import { Button } from './Button.js';
export function Message({ success, message, size }) {
    const defaultClassNames = classNames(success ? ' twds-text-success dark:twds-text-success-dark' : 'twds-text-error dark:twds-text-error-dark', size === 'lg' ? 'twds-text-sm' : 'twds-text-xs');
    return (React.createElement("div", { className: `twds-flex twds-space-x-1 twds-items-center ${defaultClassNames}` },
        success ? React.createElement(CircleCheckIcon, { size: "lg" }) : React.createElement(ExclamationCircleIcon, { size: "lg" }),
        React.createElement("span", { className: success ? 'twds-animate-fadeIn' : '' }, message)));
}
export function LoadingButton({ children, onClickCallback, dataResult, dataTestId, appearance, disabled, icon, size, addClassName, type, ...passThrough }) {
    const { loading, success, message } = dataResult;
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const handleClick = () => {
        onClickCallback?.();
    };
    useEffect(() => {
        setIsLoading(loading);
        setIsSuccessful(success);
    }, [dataResult]);
    const msg = message ? React.createElement(Message, { message: message, success: isSuccessful, size: size }) : '';
    return (React.createElement("div", { className: "twds-flex twds-space-x-2" },
        React.createElement(Button, { onClick: handleClick, appearance: appearance, isLoading: isLoading, icon: icon, disabled: disabled, dataTestId: dataTestId || `button-${typeof children === 'string' && testIdGen(children)}-loading`, size: size, addClassName: addClassName, type: type, ...passThrough },
            React.createElement("div", { className: "twds-flex twds-items-center twds-justify-center" },
                isLoading && React.createElement(LoadingIcon, { className: "twds-absolute twds-animate-spin" }),
                React.createElement("span", { className: isLoading ? 'twds-invisible' : 'twds-visible' }, children))),
        msg));
}
//# sourceMappingURL=LoadingButton.js.map